import type { NitroFetchOptions } from 'nitropack'

export function fetchWebApi<T = any>(url: string, options?: NitroFetchOptions<any>): Promise<T> {
  const config = useRuntimeConfig()
  return $fetch(url, {
    baseURL: config.public.webApiUrl || '/webapi',
    ...options,
  })
}
